import { Predicate } from '@angular/core';
import { Collection, Linked } from '@type-r/models';
import { useLinked } from '@type-r/react';
import { Link, PickItem } from 'lqx-react';
import * as React from 'react';
import { CompanyModel, globalStore, PlatformCompany } from 'api';
import { CompanyInfo } from '../../api/unresolvedPayment';
import { CreateCompanyDialog } from './createCompanyDialog';

export const PickCompany = ({ companies, disabled, $value, supplier, customer, populatedCompany, placeholder, filter, allowCompanyCreation = false, withCount = true, strictRelationship = true, onChange } : {
    companies : Collection<PlatformCompany>
    supplier? : PlatformCompany
    customer? : PlatformCompany
    $value : Linked<PlatformCompany>
    disabled? : boolean,
    populatedCompany? : CompanyInfo,
    placeholder? : string
    filter?: Predicate<PlatformCompany>,
    allowCompanyCreation? : boolean,
    onChange?: () => void,
    withCount?: boolean,
    strictRelationship?: boolean,
}) => {
    const $createCompany = useLinked(false);
    
    const companiesHavingRelationships = supplier === undefined ? 
        globalStore.getSuppliersHavingRelationships(customer) :
        (strictRelationship ? globalStore.getCustomersHavingRelationships(supplier) : globalStore.companies);

    const filtered = companies
        .filter(company => !!companiesHavingRelationships.includes(Number(company.id)))
        .sort((a, b) => a.name.localeCompare(b.name));
 
    function render( company ){
        let res = company.name;

        if( supplier ){
            const count = globalStore.relationshipsByCompanies( supplier, company ).length;
            if( count ){
                res += withCount ? ' (' + count + ')' : '';
                return <strong>{res}</strong>;
            }
        }
        else {
            const count = supplier === undefined ?
                globalStore.relationshipsBySupplier( company ).length :
                globalStore.relationshipsByCustomer( company ).length;

            if( count ){
                res += !withCount || ' (' + count + ')';
                return <strong>{res}</strong>;
            }
        }

        return res;
    }
    
    return <>
        <PickItem
            $value={$value}
            disabled={disabled}
            filter={(x, text) => {
                const name = x.name.toLowerCase();
                return text.toLowerCase().split(/\s+/).every( y => name.indexOf( y ) >= 0 );
            }}
            items={filter ? companies.filter(filter) : companies}
            placeholder={placeholder ? placeholder : "Select Company"}
            format={
                (customer : PlatformCompany ) => customer ? customer.name : ''
            }
            // bottom={
            //     allowCompanyCreation ?
            //         <Link onMouseDown={() => { 
            //             if (document.activeElement != document.body) {
            //                 (document.activeElement as HTMLElement).blur();
            //             }
            //             $createCompany.true();
            //             $value.set(null)}}
            //             >
            //             New Company
            //         </Link> : undefined 
            // }
            onChange={onChange}
            showMore
        >
            { render } 
        </PickItem>

        { $value.value && !disabled ? <Link onClick={() => { $value.set(null); onChange && onChange();} }>Clear selection</Link> : undefined }
        
        {/* { $createCompany.value ?
            <CreateCompanyDialog
                $isOpen={ $createCompany }
                $company={$value}
                companies={ companies }
                populatedCompanyName={populatedCompany && populatedCompany.name} 
            />
        : null } */}
    </>
}
